<template>
  <div id="produtos-em-promocao" class="w3-container w3-margin-top" style="padding: 0;">
    <div class="w3-col s12 m12 l12 w3-margin-bottom" v-if="processando">
      <div class="w3-panel w3-theme w3-card-2">
        <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
      </div>
    </div>

    <div 
      class="w3-panel w3-text-theme w3-bottombar w3-border-theme w3-border w3-animate-left" 
      v-if="(Object.keys(produtos_filtrados).length === 0) &&
      !processando"
      v-cloak>
      <div class="w3-container w3-white">
        <p>Não há produtos a serem exibidos.</p>
      </div>
    </div>

    <div 
      class="wrapper-componente"
      v-if="(Object.keys(produtos_filtrados).length > 0) &&
      !processando">
    
      <div 
        class=" card-item w3-container w3-margin-top" 
        v-for="(produto, produto_index) in novosProdutosFiltrados" 
        :key="produto_index">
        
        <div class="w3-col s12"> 
          <label>Data recebimento: </label>
          <strong>{{ produto.data_recebimento }}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Quantidade: </label>
          <strong>{{ produto.quantidade }}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Vendas: </label>
          <strong>R$ {{ produto.vendas }}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Vendas liquidas: </label>
          <strong>R$ {{ produto.vendas_liquidas }}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Custos: </label>
          <strong>R$ {{ produto.custos }}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Devoluções: </label>
          <strong>R$ {{ produto.devolucoes }}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Lucro: </label>
          <strong v-if="parseFloat(produto.valor_lucro) > 0" class="w3-text-green">R$ {{ produto.valor_lucro }} ({{ produto.perc_lucro }}%)</strong>
          <strong v-else class="w3-text-red">R$ {{ produto.valor_lucro }} ({{ produto.perc_lucro }}%)</strong>
          
        </div>
      </div>

      <paginacao 
        @pagina="mudarPagina" 
        :pagina-atual="paginaAtual"
        :itens-por-pagina="itensPorPagina"
        :total-resultados="totalResultados"
        :total-de-paginas="totalDePaginas" />
        
    </div><!-- wrapper-componente -->

  </div><!-- produtos-em-promocao -->
</template>

<script>
  import Paginacao from '@/components/Paginacao'
  import toastr from 'toastr'
  import ROrcamentoBuscarVendasDiaSemanaMesDashboard from '@/components/Rest/ROrcamento/ROrcamentoBuscarVendasDiaSemanaMesDashboard'
 
  export default {
    name: 'ProdutosEmPromocao',
    components: {
      Paginacao
    },
    props: ['periodo'],
    data() {
      return {
        api: process.env.API,
        produtos_cadastrados_filtrados: [],
        qtd_produtos_cadastrados_filtrados: 0,
        processando: false,
        filtro_produtos: '',
        produtos_filtrados: [],

        /* PAGINAÇÃO */
        paginaAtual: 0,
        itensPorPagina: 10,
        totalResultados: 0,
        totalDePaginas: 0
      }
    },
    methods: {
      /* PAGINAÇÃO */
      mudarPagina(numeroDaPagina) {
        this.paginaAtual = numeroDaPagina;
      },
      filtrarProdutos() {
        this.produtos_filtrados = [];
        this.mudarPagina(0);
        if(this.filtro_produtos == ''){
          this.produtos_filtrados = this.produtos_cadastrados_filtrados;
        }
        else {
          for (var i = 0; i < this.produtos_cadastrados_filtrados.length; i++) {

            if (this.produtos_cadastrados_filtrados[i].nome.toUpperCase().indexOf(this.filtro_produtos.toUpperCase()) > -1){
              this.produtos_filtrados.push(this.produtos_cadastrados_filtrados[i]);
            }
            if (this.produtos_cadastrados_filtrados[i].produto_id.replace(".", "").indexOf(this.filtro_produtos) > -1){
              this.produtos_filtrados.push(this.produtos_cadastrados_filtrados[i]);
            }
          }
        }
      },
      async buscarPedidos() {
        this.processando = true;
        try {
          let parametros = {tipo_visao: this.periodo }
          let retorno = await ROrcamentoBuscarVendasDiaSemanaMesDashboard.buscarVendasDiaSemanaMes(this.axios, parametros);
          if (retorno.houve_erro != 'N'){
            throw new Error(retorno.mensagem);
          }
          let produtos = retorno.dados.pedidos;
          for(var i = 0; i < produtos.length; i++) {
            this.produtos_cadastrados_filtrados.push(produtos[i]);
            this.qtd_produtos_cadastrados_filtrados = i+1;
          }
          this.produtos_filtrados = this.produtos_cadastrados_filtrados;
          this.processando = false;
        } catch (error) {
          this.processando = false;
          toastr.error(error);
        }
      
      }
    },
    created() {
      this.buscarPedidos();
    },
    mounted() {
      this.filtro_marca = ''
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'slow', 'swing');
    },
    computed: {
      marcas() {
        let produtos_lista_filtrada = this.produtos_filtrados;
        return produtos_lista_filtrada.filter((thing, index, self) =>
          index === self.findIndex((t) => (
            t.marca === thing.marca
          ))
        )
      },
      /* PAGINAÇÃO */
      novosProdutosFiltrados() {
        let produtos_lista_filtrada = this.produtos_filtrados;
        this.totalResultados = produtos_lista_filtrada.length;
        this.totalDePaginas =  Math.ceil(this.totalResultados / this.itensPorPagina);
        if(this.paginaAtual >= this.totalDePaginas) {
          this.paginaAtual = this.totalDePaginas;
        }

        var index = this.paginaAtual * this.itensPorPagina;
        return produtos_lista_filtrada.slice(index, index + this.itensPorPagina);
      }
    },
  }
</script>

<style scoped>
  .card-item {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }
  .titulo {
    white-space: nowrap;
    text-align: right
  }
  td {
    white-space: nowrap;
  }
  .produtos-em-promocao {
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/VendasDiaSemanaMes.vue